module.exports = __webpack_public_path__ + "df6f9cbdc6f9a83adf7186654d642262.MP3";